import { useLocation, Navigate } from "react-router"
import { RentalRequest } from "../types/rental.type"
import { RentConfirmationSection } from "./sections/rent/RentConfirmationSection"
import { useGetProject } from "../hooks/useGetProject"
import { Loading } from "./Loading"
import NotFound from "./NotFound"

function RentConfirmation() {
  const { state } = useLocation()
  const { project, isLoading } = useGetProject()

  let request: RentalRequest | undefined

  if (state && (state as { request?: RentalRequest }).request) {
    request = (state as { request: RentalRequest }).request
  }

  // Falls back to the stored copy so a refresh does not lose the reference number.
  if (!request) {
    const stored = localStorage.getItem("rentalRequestData")
    if (stored) {
      request = JSON.parse(stored) as RentalRequest
    }
  }

  if (!request) {
    return <Navigate to="/" replace />
  }

  if (isLoading) {
    return <Loading />
  }

  if (!project) {
    return <NotFound />
  }

  return <RentConfirmationSection request={request} project={project} />
}

export default RentConfirmation
